module.exports = __webpack_public_path__ + "static/media/rental-flow-jp.334720f4.png";